import React from 'react';
import { Typography } from '@mui/material';

const LoginPageHeader = () => {
  return (
    <>
    <Typography variant="h5" sx={{color:"white"}}>С возвращением</Typography>
      <Typography sx={{color:"#b9bbbe"}}>Рады снова вас видеть</Typography>
    </>
  )
}

export default LoginPageHeader
